<template lang="pug">
div(v-if="buzon")
	.cabecera
		.nombreBuzon
			span.mr-2(:class="buzon.Icono")
			| {{ buzon.Nombre }}
		.buscador
			.input-group
				input.form-control.form-contorl-sm(v-model="busqueda", @keypress.enter="buscar", @keyup="comprobarCadena" placeholder="Buscar mensajes", :disabled="buscando")
				.input-group-append
					.input-group-text
						span.fa.fa-search
	.herramientas
		.acciones
			button.btn.btn-danger(@click="prePapelera()", :disabled="seleccionados.length === 0")
				span.fa.fa-trash
			button.btn
				span.fa.fa-star
			button.btn(@click="getMensajes()")
				span.fa.fa-refresh
		.paginacion
			nav(aria-label="Paginación de mensajes")
				ul.pagination.justify-content-end
					li.page-item(
						v-for="p in paginas"
						:key="p"
						:class="pagina === p ? 'active' : ''"
						@click="verPagina(p)"
					)
						a.page-link {{ p }}
	table.table.table-hover(v-if="resultados.length === 0")
		tbody
			tr.filaMensaje(
				v-for="(mensaje, i) in listado"
				:key="mensaje.id"
				@click="onClickFila($event, mensaje.uid)"
				@contextmenu="botonDerecho($event, mensaje.uid)"
				:class="claseMensaje(mensaje)"
				@dblclick="verMensaje(mensaje.uid)"
			)
				td.text-center.text-info(@click="toggleFlag($event, mensaje, i)", style="font-size:1.3em;cursor: pointer;")
					span.favorito.fa(:class="mensaje.Flagged === 'F' ? 'fa-star' : 'fa-star-o'")
				td.text-center(style="font-size:1.3em;cursor: pointer;")
					span.fa.fa-paperclip(v-if="mensaje.hasAttachments")
				td
					span {{ mensaje.Subject }}
				td(style="max-width=250px;")
					div(style="position:relative;display:inline-block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;max-width: 300px;")
						span(v-if="/Sent/.test(buzon.Name)") {{ mensaje.toaddress }}
						span(v-else) {{ mensaje.fromaddress }}
				td
					span {{ mensaje.date | moment('DD-MM-YYYY HH:mm:ss')}}
	table.table.table-hover(v-else)
		tbody
			tr.filaMensaje(
				v-for="(mensaje, i) in resultados"
				:key="mensaje.id"
				@click="onClickFila($event, mensaje.uid)"
				@mousedown="botonDerecho($event)"
				:class="claseMensaje(mensaje)"
				@dblclick="verMensaje(mensaje.uid)"
			)
				td.text-center.text-info(@click="toggleFlag($event, mensaje, i)", style="font-size:1.3em;cursor: pointer;")
					span.favorito.fa(:class="mensaje.Flagged === 'F' ? 'fa-star' : 'fa-star-o'")
				td.text-center(style="font-size:1.3em;cursor: pointer;")
					span.fa.fa-paperclip(v-if="mensaje.hasAttachments")
				td
					span {{ mensaje.Subject }}
				td(style="max-width=250px;")
					div(style="position:relative;display:inline-block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;max-width: 300px;")
						span(v-if="/Sent/.test(buzon.Name)") {{ mensaje.toaddress }}
						span(v-else) {{ mensaje.fromaddress }}
				td
					span {{ mensaje.date | moment('DD-MM-YYYY HH:mm:ss')}}
	VisorMensaje(v-if="ver", :numero="ver", @cerrar="cerrarMensaje")
	.fondoContextual(v-if="verContextual", @click="verContextual = null")
		.contextual(:style="verContextual")
			div.bg-light.p-2.pl-4
				span.fa.fa-gear.mr-2
				b Opciones
			ul.list-group
				li.list-group-item.list-group-item-action(v-if="seleccionados.length === 1")
					span.fa.fa-reply.mr-2
					| Responder
				li.list-group-item.list-group-item-action(@click="seleccionarBuzon = true")
					span.fa.fa-copy.mr-2
					| Mover a otro buzón
				li.list-group-item.list-group-item-action(v-if="seleccionNoLeidos || !seleccionLeidos", @click="marcaLeido(true)")
					span.fa.fa-eye.mr-2
					| Marcar como leído
				li.list-group-item.list-group-item-action(v-if="seleccionLeidos || !seleccionNoLeidos", @click="marcaLeido(false)")
					span.fa.fa-eye-slash.mr-2
					| Marcar como no leído
				li.list-group-item.list-group-item-action(@click="setFav('F')", v-if="soloNoFavoritos || !soloFavoritos")
					span.fa.fa-star.mr-2
					| Marcar como favorito
				li.list-group-item.list-group-item-action(@click="setFav('')", v-if="soloFavoritos || !soloNoFavoritos")
					span.fa.fa-star-o.mr-2
					| Quitar marca de favorito
				li.list-group-item.list-group-item-action(@click="prePapelera()")
					span.fa.fa-trash.mr-2
					| Enviar a la papelera
				li.list-group-item.list-group-item-action(@click="enviarSpam()")
					span.fa.fa-bug.mr-2
					| Marcar como spam
	VistaBuzones(v-if="seleccionarBuzon", @cerrar="seleccionarBuzon = false", @seleccion="enviarBuzon({uid: seleccionados, Destino: $event.Path})")
</template>

<script>
import Servicio from '../../servicios'
import VisorMensaje from './visorMensaje'
import VistaBuzones from './vistaBuzones'
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
	components: {
		VisorMensaje,
		VistaBuzones
	},
	data () {
		return {
			seleccionados: [],
			resultados: [],
			ver: null,
			intervalo: 1,
			total: 0,
			busqueda: '',
			buscando: false,
			verContextual: null,
			seleccionarBuzon: false
		}
	},
	watch: {
		buzon: function () {
			this.seleccionados = []
		}
	},
	computed: {
		...mapGetters({
			mensajes: 'webmail/mensajes',
			buzon: 'webmail/buzonActivo',
			pagina: 'webmail/pagina'
		}),
		paginas () {
			const total = Math.ceil(this.buzon.mensajes / 100)
			const arr = []
			for (let i = 1; i <= total; i++) {
				arr.push(i)
			}
			return arr
		},
		listado () {
			return this.mensajes.reduce((acc, m, i) => {
				m.id = m.message_id + '-' + i + '-' + m.Size
				acc.push(m)

				// Comprobamos si tiene adjunto
				m.hasAttachments = m.estructura.reduce((hay, part) => {
					if (part.part_object) {
						hay = part.part_object.type > 2 ? true : hay
					}
					return hay
				}, false)
				return acc
			}, [])
		},
		// Devuelve true cuando la selección es solo de mensaje favoritos
		soloFavoritos () {
			return this.seleccionados.reduce((acc, uid) => {
				const mensaje = this.mensajes.filter(m => m.uid === uid)
				if (mensaje.length === 1) {
					acc = (mensaje[0].Flagged !== 'F') ? false : acc
				}
				return acc
			}, true)
		},
		// Devuelve true cuando la selección es solo de mensajes no favoritos
		soloNoFavoritos () {
			return this.seleccionados.reduce((acc, uid) => {
				const mensaje = this.mensajes.filter(m => m.uid === uid)
				if (mensaje.length === 1) {
					acc = (mensaje[0].Flagged !== ' ') ? false : acc
				}
				return acc
			}, true)
		},
		seleccionLeidos () {
			return this.seleccionados.reduce((acc, uid) => {
				const mensaje = this.mensajes.filter(m => m.uid === uid)
				if (mensaje.length > 0) {
					acc = mensaje[0].Unseen === 'U' ? false : acc
				}
				return acc
			}, true)
		},
		seleccionNoLeidos () {
			return this.seleccionados.reduce((acc, uid) => {
				const mensaje = this.mensajes.filter(m => m.uid === uid)
				if (mensaje.length > 0) {
					acc = mensaje[0].Unseen !== 'U' ? false : acc
				}
				return acc
			}, true)
		}
	},
	created () {
		// this.getMensajes()
		this.intervalo = window.setInterval(() => {
			this.getMensajes()
		}, 60000)
		window.addEventListener('keypress', this.onTeclaPulsadaEnFila)
	},
	beforeDestroy () {
		window.clearInterval(this.intervalo)
		window.removeEventListener('keypress', this.onTeclaPulsadaEnFila)
	},
	methods: {
		...mapActions({
			getMensajes: 'webmail/getMensajes',
			setFlag: 'webmail/setFlag',
			enviarPapelera: 'webmail/enviarPapelera',
			enviarBuzon: 'webmail/enviarBuzon',
			setLeido: 'webmail/setLeido'
		}),
		...mapMutations({
			setPagina: 'webmail/SET_PAGINA'
		}),
		verPagina (pagina) {
			this.setPagina(pagina)
			this.getMensajes()
		},
		comprobarCadena () {
			if (this.busqueda === '') {
				this.getMensajes()
			}
		},
		botonDerecho (ev, uid) {
			ev.preventDefault()
			ev.stopPropagation()
			if (!ev.ctrlKey && this.seleccionados.length <= 1) {
				this.seleccionados = [uid]
			}

			const altoPantalla = window.innerHeight
			const anchoPantalla = window.innerWidth
			const clickX = ev.clientX
			const clickY = ev.clientY

			let top, bottom, left, right
			if (altoPantalla / 2 > clickY) {
				top = clickY + 'px'
				bottom = 'auto'
			} else {
				top = 'auto'
				bottom = (altoPantalla - clickY) + 'px'
			}

			if (anchoPantalla / 2 > clickX) {
				left = clickX + 'px'
				right = 'auto'
			} else {
				left = 'auto'
				right = (anchoPantalla - clickX) + 'px'
			}
			this.verContextual = {
				top: top,
				bottom: bottom,
				left: left,
				right: right
			}
		},
		buscar () {
			this.buscando = true
			Servicio.Buscar(this.email, this.buzon.Name, this.busqueda)
				.then(listado => {
					this.resultados = listado
					this.buscando = false
				})
				.catch(e => {
					this.$error(e)
				})
		},
		verMensaje (numero) {
			this.ver = numero
		},
		cerrarMensaje () {
			this.ver = null
			window.setTimeout(() => {
				this.$store.commit('webmail/SET_MENSAJE', null)
			}, 300)
		},
		claseMensaje (m) {
			let clase = []
			if (this.seleccionados.indexOf(m.uid) >= 0) {
				clase.push('bg-warning')
			}

			if (m.Recent === 'R' || m.Unseen === 'U') {
				clase.push('mensajeNuevo')
			} else {
				clase.push('mensajeLeido')
			}

			return clase.join(' ')
		},
		toggleFlag (ev, mensaje, i) {
			ev.preventDefault()
			ev.stopPropagation()
			const flag = this.mensajes[i].Flagged === 'F' ? '' : 'F'
			this.setFlag({numero: [mensaje.uid], flag: flag})
		},
		setFav (flag) {
			this.setFlag({numero: this.seleccionados, flag: flag})
		},
		marcaLeido (leido) {
			this.setLeido({numero: this.seleccionados, leido: leido})
		},
		prePapelera () {
			if (this.seleccionados.length === 0) {
				return
			}
			this.verContextual = null
			this.$store.commit('alertas/confirm', {
				titulo: 'Enviar a la papelera',
				mensaje: `¿Quieres mandar estos mensajes a la papelera?`,
				callback: acepta => {
					if (acepta) {
						this.enviarBuzon({uid: this.seleccionados, Destino: 'Trash'})
						this.seleccionados = []
					}
				}
			})
		},
		enviarSpam () {
			this.enviarBuzon({uid: this.seleccionados, Destino: 'Junk'})
		},
		onTeclaPulsadaEnFila (ev, mensaje) {
			if (ev.keyCode === 127) {
				// Suprimir... suprimimos
				this.prePapelera()
			}
		},
		onClickFila (ev, mensajeId) {
			if (ev.shiftKey) {
				if (this.seleccionados.length === 0) {
					this.seleccionados = [mensajeId]
				} else if (this.seleccionados[0] > mensajeId) {
					this.seleccionados = this.mensajes.filter(m => (m.uid >= mensajeId && m.uid <= this.seleccionados[0])).map(m => m.uid)
				} else {
					this.seleccionados = this.mensajes.filter(m => (m.uid >= this.seleccionados[0] && m.uid <= mensajeId)).map(m => m.uid)
				}
			} else if (ev.ctrlKey) {
				const ind = this.seleccionados.indexOf(mensajeId)
				if (ind >= 0) {
					this.seleccionados.splice(ind, 1)
				} else {
					this.seleccionados.push(mensajeId)
				}
			} else {
				this.seleccionados = [mensajeId]
			}
		}
	}
}
</script>

<style scoped>
.cabecera {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.nombreBuzon {
	flex-grow: 1;
	flex-shrink: 1;
	padding: 15px;
	font-size: 2em;
	font-weight: bold;
}

.buscador {
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 250px;
	width: 250px;
	min-width: 250px;
	max-width: 250px;
	padding-right: 15px;
}

.filaMensaje {
	cursor: default;
}

.filaMensaje > td {
	vertical-align: middle;
	padding: 3px;
	user-select: none;
}

.mensajeNuevo {
	font-weight: bold;
	background-color: white;
}

.mensajeLeido {
	background-color: #f9f9f9;
}
.herramientas {
	display: flex;
	flex-direction: row;
	margin-bottom: 10px;
	padding: 15px;
	width: 100%;
}

.herramientas > .acciones > button {
	margin: 2px;
}

.herramientas > .paginacion {
	text-align: right;
	flex-grow: 1;
	flex-shrink: 1;
}

.fondoContextual {
	position: fixed;
	display: block;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 99;
}
.contextual {
	position: fixed;
	display: block;
	width: 300px;
	background-color: white;
	box-shadow: 0 0 18px rgba(0,0,0,0.2);
	z-index: 100;
	border-radius: 2px;
}

ul.list-group > li {
	cursor: default;
}
</style>


// WEBPACK FOOTER //
// src/modulos/webmail/vue/components/mensajes/mensajes.vue